import { StyledTableHead, StyledTableRow } from '../styles'
import type { TableProps } from '../types'

type TableHeadProps = Required<Pick<TableProps, 'headings' | 'fontWeight'>>

export const TableHead = ({ headings, ...commonProps }: TableHeadProps) => {
  if (!headings.length) return null
  return (
    <thead role="rowgroup">
      <StyledTableRow className="table__first-row" role="row" {...commonProps}>
        {headings.map((heading, index) => (
          <StyledTableHead aria-sort="none" role="columnheader" key={index} {...commonProps}>
            {heading.text}
          </StyledTableHead>
        ))}
      </StyledTableRow>
    </thead>
  )
}
